import React from 'react';
import PropTypes from 'prop-types';
import {
    Page,
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer";
import moment from "moment-timezone";
import t from "../../../languages/pl";
import { calcDurationFromEpoch } from './../../../utils/helpers';

const defaultClasses = StyleSheet.create({
    cellWidth: {
        width: "12.5%",
    }
});

const RoutesTable = props => {
    const { classes = defaultClasses, title, routes } = props;

    const drawTable = (data) => {
        let i = 0;
        if (Array.isArray(data)) {
            return data.map(row => {
                let duration = calcDurationFromEpoch(row.data_od, row.data_do);
                return (
                    <View
                        key={i++}
                        style={classes.row}
                        break={i % 20 === 0}
                    >
                        <View style={[classes.cell, defaultClasses.cellWidth]}>
                            <Text style={classes.textPrimary}>
                                {moment.unix(row.data_od).format("DD/MM/YYYY \n HH:mm:ss")}
                            </Text>
                        </View>
                        <View style={[classes.cell, defaultClasses.cellWidth]} wrap>
                            <Text style={classes.textPrimary}>
                                {moment.unix(row.data_do).format("DD/MM/YYYY \n HH:mm:ss")}
                            </Text>
                        </View>
                        <View style={[classes.cell, defaultClasses.cellWidth]}>
                            <Text style={classes.textPrimary}>
                                {row.kierowca}
                            </Text>
                        </View>
                        <View style={[classes.cell, defaultClasses.cellWidth]}>
                            <Text style={classes.textPrimary}>
                                {row.dystans}
                            </Text>
                        </View>
                        <View style={[classes.cell, defaultClasses.cellWidth]}>
                            <Text style={classes.textPrimary}>
                                b.d.
                            </Text>
                        </View>
                        <View style={[classes.cell, defaultClasses.cellWidth]}>
                            <Text style={classes.textPrimary}>
                                {row.predkosc_max}
                            </Text>
                        </View>
                        <View style={[classes.cell, defaultClasses.cellWidth]}>
                            <Text style={classes.textPrimary}>
                                {row.predkosc_sr}
                            </Text>
                        </View>
                        <View style={[classes.cell, defaultClasses.cellWidth, { borderRight: 1 }]}>
                            <Text style={classes.textPrimary}>
                                {duration.get("hours") > 0 ? duration.get("hours") + t.hoursAbbreviation : ''}
                                &nbsp;
                                {duration.get("minutes")}{t.minutesAbbreviation}
                            </Text>
                        </View>
                    </View>
                );
            });
        }
    };

    return (
        <Page
            style={classes.page}
            orientation="portrait"
        >
            <View style={classes.title}>
                <Text style={classes.textHeader}>
                    {title}
                </Text>
            </View>
            <View style={classes.table}>
                <View style={[classes.row, classes.headerCell]}>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            {t.dateFrom}:
                            </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            {t.dateTo}:
                            </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            {t.driver}
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            {t.distance}
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            Adres końca trasy
                            </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            {t.speed}
                        </Text>
                        <Text style={classes.textPrimary}>
                            {t.max}
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell]}>
                        <Text style={classes.textPrimary}>
                            {t.speed}
                        </Text>
                        <Text style={classes.textPrimary}>
                            {t.average}
                        </Text>
                    </View>
                    <View style={[classes.cell, defaultClasses.cellWidth, classes.headerCell, { borderRight: 1 }]}>
                        <Text style={classes.textPrimary}>
                            {t.timeBehindTheWheel}
                        </Text>
                    </View>
                </View>
                <View>
                    {drawTable(routes)}
                </View>
            </View>
        </Page>
    );
};

RoutesTable.propTypes = {
    classes: PropTypes.object,
    routes: PropTypes.array,
    title: PropTypes.string
};

export default RoutesTable;
